import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import StepperActions from "../../components/StepperActions";
import { useSearchParams } from "../../../../hooks/searchParams";
import { requestConfigData, setConfigData } from "../../services/general/actions";

import StepTwoConfigurator from "./StepTwoConfigurator";

const TwoNew = () => {
    const dispatch = useDispatch();
    const searchParams = useSearchParams();

    useEffect(
        () => {
            dispatch(requestConfigData(searchParams));

            return () => {
                dispatch(setConfigData({}));
            };
        },
        [ dispatch, searchParams ]
    );

    return (
        <>
            <StepperActions activeStep={1} />

            <StepTwoConfigurator />
        </>
    );
};

export default TwoNew;
